import { DynamicIcon } from '@purpurds/purpur/dynamic-icon';

import { IconNames } from './IconList';

export declare type IconName = keyof typeof IconNames;

interface Props {
  iconName: IconName;
  size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const PurpurIcon = ({ iconName, size = 'md', className }: Props) => {
  return <DynamicIcon name={iconName} size={size} className={className} />;
};

export default PurpurIcon;
